import { createSlice, PayloadAction, Dispatch } from "@reduxjs/toolkit";

interface UiState {
  isMobile: boolean;
  isSmallScreen: boolean;
}

const initialState: UiState = {
  isMobile: window.innerWidth < 430,
  isSmallScreen: window.innerWidth < 660,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setIsMobile(state, action: PayloadAction<boolean>) {
      state.isMobile = action.payload;
    },
    setIsSmallScreen(state, action: PayloadAction<boolean>) {
      state.isSmallScreen = action.payload;
    },
    setScreenSize(state) {
      state.isMobile = window.innerWidth < 430;
      state.isSmallScreen = window.innerWidth < 660;
    },
  },
});

// Call once on app bootstrap to keep UI flags in sync with viewport size.
// Returns a cleanup function to remove the listener.
export const attachUiResizeListener = (dispatch: Dispatch) => {
  const update = () => dispatch(setScreenSize());

  // initialize immediately
  update();

  window.addEventListener("resize", update);
  return () => window.removeEventListener("resize", update);
};

export const { setIsMobile, setIsSmallScreen, setScreenSize } = uiSlice.actions;

export default uiSlice.reducer;
